import { Component, Inject, Injector, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditorComponentBaseDirective } from '@app/shared/base';
import { takeUntil } from 'rxjs';
import { AuthService, LanguageService } from '@app/shared/services';
import { SelectListItem } from '@app/shared/models';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.scss']
})
export class PasswordChangeComponent extends EditorComponentBaseDirective<object>
  implements OnInit {

  // Attributes
  Object = Object;
  public hide: boolean = true;
  public languageList: SelectListItem[];
  public defaultLanguage: string;


  // Constructor
  constructor(
    public override dialogRef: MatDialogRef<EditorComponentBaseDirective<object>>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private langService: LanguageService,
    private translate: TranslateService,
    private authService: AuthService,
    injector: Injector,
  ) {
    super(authService, dialogRef, "0", injector, false);
    this.title = data;
    this.id = "0";
  }




  // Functions
  createFormGroupWithBuilderAndModel(data: object): FormGroup<any> {
    var dynamicFormGroup = {};
    let k: keyof typeof data;
    for (const k in data) {
      dynamicFormGroup[k] = new FormControl(data[k]);
    }
    return this.fromBuilder.group(dynamicFormGroup);
  }

  readForm(): object {
    var readValue = this.formGroup.value;
    return readValue;
  }

  public override ngOnInit(): void {
    switch (this.title) {
      case 'changeLanguage':
        this.getSelectLists();
        break;
      case 'changePassword':
        this.formGroup = this.createFormGroupWithBuilderAndModel({ newPassword: "" });
        break;
      default:
        break;
    }
  }

  public override onSubmit() {
    switch (this.title) {
      case 'changePassword':
        let newPassword = this.formGroup.getRawValue();
        this.authService
          .changePassword(newPassword)
          .subscribe((r) => {
            this.dialogRef.close(true);
          });
        break;
    }
  }


  public getSelectLists(): void {
    this.getLanguageList();
    this.getDefLang();
  }

  public getLanguageList(): void {
    this.langService.getLanguages(true, false).subscribe(r => {
      this.languageList = r;
    });
  }

  public getDefLang(): void {
    this.formGroup = this.createFormGroupWithBuilderAndModel({ selectLanguage: localStorage.getItem('lang') });
  }

}
